<template>
  <v-card>
    <v-card-title>
      指名系集計（タグ別×受領者別）
    </v-card-title>
    <v-card-text>
      <v-skeleton-loader
        v-if="isLoading"
        type="table"
      />

      <div v-else-if="hasData">
        <div style="overflow-x: auto;">
          <v-simple-table dense>
            <template #default>
              <thead>
                <tr>
                  <th class="sticky-left">
                    受領者
                  </th>
                  <th
                    v-for="tag in nominationStats.vendibleTags"
                    :key="tag"
                    class="text-center"
                  >
                    {{ tag }}
                  </th>
                  <th class="text-center grey lighten-3">
                    合計
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr
                  v-for="recipient in nominationStats.recipients"
                  :key="recipient.recipientId"
                >
                  <td class="sticky-left font-weight-medium">
                    {{ recipient.recipientName || '未指定' }}
                  </td>
                  <td
                    v-for="tag in nominationStats.vendibleTags"
                    :key="tag"
                    class="text-center"
                  >
                    {{ recipient.byTag[tag] || 0 }}
                  </td>
                  <td class="text-center grey lighten-4 font-weight-bold">
                    {{ recipient.total }}
                  </td>
                </tr>
              </tbody>
              <tfoot class="grey lighten-3">
                <tr>
                  <td class="sticky-left font-weight-bold">
                    合計
                  </td>
                  <td
                    v-for="tag in nominationStats.vendibleTags"
                    :key="tag"
                    class="text-center font-weight-bold"
                  >
                    {{ nominationStats.totalsByTag[tag] || 0 }}
                  </td>
                  <td class="text-center font-weight-bold">
                    {{ nominationStats.grandTotal }}
                  </td>
                </tr>
              </tfoot>
            </template>
          </v-simple-table>
        </div>
      </div>

      <div
        v-else
        class="text-center text--secondary"
      >
        ノミネーション履歴がありません
      </div>
    </v-card-text>
  </v-card>
</template>

<script>
import {
  ref,
  computed,
  watch,
  getCurrentInstance,
} from '@vue/composition-api'
import CustomerNominationStatsApi from '@/api/waiter/CustomerNominationStats'

export default {
  name: 'CustomerNominationStats',
  props: {
    customerId: {
      type: [Number, String],
      default: null,
    },
  },
  setup(props) {
    const vm = getCurrentInstance().proxy

    const isLoading = ref(false)
    const nominationStats = ref({
      vendibleTags: [],
      recipients: [],
      totalsByTag: {},
      grandTotal: 0,
    })

    const hasData = computed(() => {
      return nominationStats.value.recipients.length > 0
    })

    const fetchNominationStats = async () => {
      if (!props.customerId) return

      const customerIdNum = Number(props.customerId)
      if (Number.isNaN(customerIdNum) || customerIdNum <= 0) return

      isLoading.value = true
      try {
        const res = await CustomerNominationStatsApi.getCustomerNominationStats(customerIdNum)
        if (res?.data) {
          nominationStats.value = res.data
        }
      } catch (error) {
        console.error('Failed to fetch nomination stats:', error)
        if (error?.response?.status !== 404) {
          vm.$toast.error('ノミネーション集計の取得に失敗しました')
        }
      } finally {
        isLoading.value = false
      }
    }

    watch(
      () => props.customerId,
      newVal => {
        if (newVal) {
          fetchNominationStats()
        }
      },
      { immediate: true },
    )

    return {
      isLoading,
      nominationStats,
      hasData,
      fetchNominationStats,
    }
  },
}
</script>

<style scoped>
.sticky-left {
  position: sticky;
  left: 0;
  background-color: inherit;
  z-index: 1;
}
</style>
